import script from "./SelectInputController.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInputController.vue?vue&type=script&setup=true&lang=js"

import "./SelectInputController.vue?vue&type=style&index=0&id=24fa5cc3&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24fa5cc3"]])

export default __exports__